import { BaseDAO } from './baseDAO';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { HttpHeaders } from '@angular/common/http';
import { AbandonedBuyflow } from 'anchor-shared/lib/model/entity/abandonedBuyflow';

@Injectable()
export class AbandonedBuyflowDAO extends BaseDAO<string> {
  constructor(public readonly apiHelper: ApiHelper) {
    super(apiHelper, ConstantMan.API.RESOURCE.ABANDONED_BUYFLOW);
  }

  public createFromEmailData(abandonedBuyflow: any): Observable<any> {
    const url: string = `${this.apiHelper.getServiceName()}${this.getResource()}/create`;
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    let data = {
      abandonedBuyflow: abandonedBuyflow,
    };
    return this.apiHelper.apiCall<any>(url, method, null, data, headers);
  }

  public getAffiliateLeads(
    fromDate: string,
    toDate: string,
  ): Observable<AbandonedBuyflow[]> {
    const url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/affiliate-leads';
    const method = 'PUT';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const data = {
      fromDate: fromDate,
      toDate: toDate,
    };
    return this.apiHelper.apiCall<AbandonedBuyflow[]>(
      url,
      method,
      null,
      data,
      headers,
    );
  }
}
